// frontend/src/App.js
import { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './contexts/AuthContext';
import Layout from './layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import RegisterPage from './pages/RegisterPage';
import ReaderDashboard from './pages/ReaderDashboard';
import EditorDashboard from './pages/EditorDashboard';
import AdminDashboard from './pages/AdminDashboard';
import HomePage from './pages/HomePage';

import BookReading from './components/BookReading/BookReading';
import BookList from './components/BookReading/BookList';
import ChapterList from './components/BookReading/ChapterList';
import ChapterReader from './components/BookReading/ChapterReader';

import BookEditing from './components/BookEditing/BookEditing';
import ChapterEditing from './components/ChapterEditing/ChapterEditing';
import TaskManagement from './components/TaskManagement/TaskManagement';
import RoleChanging from './components/RoleChanging/RoleChanging';
import UserProfileEditor from './components/UserProfileEditor/UserProfileEditor';
import Geo from './components/Geo/Geo';
import ProductList from './components/ProductList/ProductList';

import ResetPassword from './components/ResetPassword/ResetPassword';
import CommentManagement from './components/Comment/CommentManagement';
import MyComments from './components/Comment/MyComments';
import CommentDeletedManagement from './components/Comment/CommentDeletedManager';
import ConfigList from './components/Configuration/ConfigList';

// Rota /login antiga: não há mais página de login — abre o popup e vai pra Home.
function LoginRedirect() {
  const { setLoginModalOpen } = useContext(AuthContext);
  useEffect(() => { setLoginModalOpen(true); }, [setLoginModalOpen]);
  return <Navigate to="/" replace />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />

            <Route path="login" element={<LoginRedirect />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="reset-password" element={<ResetPassword />} />

            <Route
              path="reader"
              element={
                <ProtectedRoute allowedRoles={['READER']}>
                  <ReaderDashboard />
                </ProtectedRoute>
              }
            >
              <Route index element={<HomePage />} />
              
              {/* Rotas dinâmicas para leitura */}
              <Route path="read" element={<BookReading />}>
                <Route index element={<BookList />} />
                <Route path="book/:bookId" element={<ChapterList />} />
                <Route path="chapter/:chapterId" element={<ChapterReader />} />
              </Route>
              
              <Route path="profile" element={<UserProfileEditor />} />
              <Route path="comment" element={<MyComments />} />
            </Route>
            
            <Route
              path="editor"
              element={
                <ProtectedRoute allowedRoles={['EDITOR']}>
                  <EditorDashboard />
                </ProtectedRoute>
              }
            >
              <Route index element={<HomePage />} />
              
              {/* Rotas dinâmicas para leitura */}
              <Route path="read" element={<BookReading />}>
                <Route index element={<BookList />} />
                <Route path="book/:bookId" element={<ChapterList />} />
                <Route path="chapter/:chapterId" element={<ChapterReader />} />
              </Route>
              
              <Route path="edit-books" element={<BookEditing />} />
              <Route path="edit-chapters" element={<ChapterEditing />} />
              <Route path="tasks" element={<TaskManagement />} />
              <Route path="comment" element={<CommentManagement />} />
              <Route path="profile" element={<UserProfileEditor />} />
              <Route path="productList" element={<ProductList />} /> 
            </Route>
            
            <Route
              path="admin"
              element={
                <ProtectedRoute allowedRoles={['ADMIN']}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            >
              <Route index element={<HomePage />} />
              <Route path="roles" element={<RoleChanging />} />
              
              {/* Rotas dinâmicas para leitura */}
              <Route path="read" element={<BookReading />}>
                <Route index element={<BookList />} />
                <Route path="book/:bookId" element={<ChapterList />} />
                <Route path="chapter/:chapterId" element={<ChapterReader />} />
              </Route>
              
              <Route path="edit-books" element={<BookEditing />} />
              <Route path="edit-chapters" element={<ChapterEditing />} />
              <Route path="tasks" element={<TaskManagement />} />
              <Route path="comment" element={<CommentManagement />} />
              <Route path="comment-deleted" element={<CommentDeletedManagement />} />
              <Route path="profile" element={<UserProfileEditor />} /> 
              <Route path="productList" element={<ProductList />} /> 
              <Route path="configList" element={<ConfigList />} />
               <Route path="geo" element={<Geo />} /> 
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

